import wrapper from "./wrapper";

export default {
  counts: (q, opts) => wrapper("waldoLazySearch", q, opts),
  book: (isbn, q) => wrapper("waldoSearchBook", isbn, q),
  metadata: q => wrapper("searchMetadata", q)
};
